import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'kendo-textbox',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: MaxLengthTextboxDirective,
            multi: true
        }
    ],
    standalone: false
})
export class MaxLengthTextboxDirective implements Validator {
    readonly defaultMaxLength: number = 100;
    @Input() maxlength: number = this.defaultMaxLength;

    validate(control: AbstractControl): ValidationErrors | null {
        if (!control?.value) {
            return null;
        }

        return control.value.length > this.maxlength
            ? { maxlength: { requiredLength: this.maxlength, actualLength: control.value.length } }
            : null;
    }
}
